import React from 'react';
import variables from '../../../utils/variables';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NameTextField from './NameTextField';
import EmailTextField from './EmailTextField';
import CommentTextField from './CommentTextField';
import { Button } from '@material-ui/core';
import './index.css';
import { isValidEmail } from '../../../utils/validation';
import { setComment, setEmail, setName, submitContactDetails } from '../../../actions/contact';
import CircularProgress from '../../../components/CircularProgress/IconLoader';

const Contact = (props) => {
    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && !disable) {
            handleSend();
        }
    };

    const handleSend = () => {
        const valid = isValidEmail(props.email);
        props.setEmail(props.email, valid);
        props.setName(props.name, props.name !== '');
        props.setComment(props.comment, props.comment !== '');

        const data = {
            name: props.name,
            emailAddress: props.email,
            message: props.comment,
        };

        if (valid && props.name !== '' && props.comment !== '') {
            props.submitContactDetails(data);
        }
    };

    const disable = props.inProgress;

    return (
        <section className="contact" id="contact">
            <div className="heading">
                <h2>{variables[props.lang]['get_in_touch']}</h2>
                <p>{variables[props.lang]['info_mail']}</p>
            </div>
            <form
                noValidate
                autoComplete="off"
                className="form"
                onKeyPress={handleKeyPress}
                onSubmit={(e) => {
                    e.preventDefault();
                }}>
                <NameTextField/>
                <EmailTextField/>
                <CommentTextField/>
                <div className="button_div">
                    <Button
                        disabled={disable}
                        variant="contained"
                        onClick={handleSend}>
                        {variables[props.lang].send}
                    </Button>
                    {disable && <CircularProgress/>}
                </div>
            </form>
        </section>
    );
};

Contact.propTypes = {
    comment: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    inProgress: PropTypes.bool.isRequired,
    lang: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    setComment: PropTypes.func.isRequired,
    setEmail: PropTypes.func.isRequired,
    setName: PropTypes.func.isRequired,
    submitContactDetails: PropTypes.func.isRequired,
};

const stateToProps = (state) => {
    return {
        comment: state.contact.comment.value,
        email: state.contact.email.value,
        inProgress: state.contact.contactInProgress,
        lang: state.language,
        name: state.contact.name.value,
    };
};

const actionsToProps = {
    submitContactDetails,
    setEmail,
    setComment,
    setName,
};

export default connect(stateToProps, actionsToProps)(Contact);
